import { type AWSRegion, EU_WEST_1, US_EAST_1 } from '../aws';

export const countryToAwsRegion = new Map<string, AWSRegion>([
  // Europe -> eu-west-1
  ['al', EU_WEST_1],
  ['ad', EU_WEST_1],
  ['at', EU_WEST_1],
  ['by', EU_WEST_1],
  ['be', EU_WEST_1],
  ['ba', EU_WEST_1],
  ['bg', EU_WEST_1],
  ['hr', EU_WEST_1],
  ['cy', EU_WEST_1],
  ['cz', EU_WEST_1],
  ['dk', EU_WEST_1],
  ['ee', EU_WEST_1],
  ['fi', EU_WEST_1],
  ['fr', EU_WEST_1],
  ['de', EU_WEST_1],
  ['gr', EU_WEST_1],
  ['hu', EU_WEST_1],
  ['is', EU_WEST_1],
  ['ie', EU_WEST_1],
  ['it', EU_WEST_1],
  ['lv', EU_WEST_1],
  ['li', EU_WEST_1],
  ['lt', EU_WEST_1],
  ['lu', EU_WEST_1],
  ['mt', EU_WEST_1],
  ['mc', EU_WEST_1],
  ['me', EU_WEST_1],
  ['nl', EU_WEST_1],
  ['mk', EU_WEST_1],
  ['no', EU_WEST_1],
  ['pl', EU_WEST_1],
  ['pt', EU_WEST_1],
  ['ro', EU_WEST_1],
  ['ru', EU_WEST_1],
  ['sm', EU_WEST_1],
  ['rs', EU_WEST_1],
  ['sk', EU_WEST_1],
  ['si', EU_WEST_1],
  ['es', EU_WEST_1],
  ['se', EU_WEST_1],
  ['ch', EU_WEST_1],
  ['ua', EU_WEST_1],
  ['gb', EU_WEST_1],
  ['va', EU_WEST_1],

  // North America -> us-east-1
  ['us', US_EAST_1],
  ['ca', US_EAST_1],
  ['mx', US_EAST_1],

  // Central America -> us-east-1
  ['bz', US_EAST_1],
  ['cr', US_EAST_1],
  ['sv', US_EAST_1],
  ['gt', US_EAST_1],
  ['hn', US_EAST_1],
  ['ni', US_EAST_1],
  ['pa', US_EAST_1],

  // South America -> us-east-1
  ['ar', US_EAST_1],
  ['bo', US_EAST_1],
  ['br', US_EAST_1],
  ['cl', US_EAST_1],
  ['co', US_EAST_1],
  ['ec', US_EAST_1],
  ['gy', US_EAST_1],
  ['py', US_EAST_1],
  ['pe', US_EAST_1],
  ['sr', US_EAST_1],
  ['uy', US_EAST_1],
  ['ve', US_EAST_1],

  // Africa -> eu-west-1
  ['dz', EU_WEST_1],
  ['ao', EU_WEST_1],
  ['bj', EU_WEST_1],
  ['bw', EU_WEST_1],
  ['bf', EU_WEST_1],
  ['bi', EU_WEST_1],
  ['cm', EU_WEST_1],
  ['cv', EU_WEST_1],
  ['cf', EU_WEST_1],
  ['td', EU_WEST_1],
  ['km', EU_WEST_1],
  ['cd', EU_WEST_1],
  ['dj', EU_WEST_1],
  ['eg', EU_WEST_1],
  ['gq', EU_WEST_1],
  ['er', EU_WEST_1],
  ['sz', EU_WEST_1],
  ['et', EU_WEST_1],
  ['ga', EU_WEST_1],
  ['gm', EU_WEST_1],
  ['gh', EU_WEST_1],
  ['gn', EU_WEST_1],
  ['gw', EU_WEST_1],
  ['ci', EU_WEST_1],
  ['ke', EU_WEST_1],
  ['ls', EU_WEST_1],
  ['lr', EU_WEST_1],
  ['ly', EU_WEST_1],
  ['mg', EU_WEST_1],
  ['mw', EU_WEST_1],
  ['ml', EU_WEST_1],
  ['mr', EU_WEST_1],
  ['mu', EU_WEST_1],
  ['yt', EU_WEST_1],
  ['ma', EU_WEST_1],
  ['mz', EU_WEST_1],
  ['na', EU_WEST_1],
  ['ne', EU_WEST_1],
  ['ng', EU_WEST_1],
  ['cg', EU_WEST_1],
  ['re', EU_WEST_1],
  ['rw', EU_WEST_1],
  ['st', EU_WEST_1],
  ['sn', EU_WEST_1],
  ['sc', EU_WEST_1],
  ['sl', EU_WEST_1],
  ['so', EU_WEST_1],
  ['za', EU_WEST_1],
  ['ss', EU_WEST_1],
  ['sd', EU_WEST_1],
  ['tz', EU_WEST_1],
  ['tg', EU_WEST_1],
  ['tn', EU_WEST_1],
  ['ug', EU_WEST_1],
  ['eh', EU_WEST_1],
  ['zm', EU_WEST_1],
  ['zw', EU_WEST_1],

  // Middle East -> eu-west-1
  ['ae', EU_WEST_1],
  ['bh', EU_WEST_1],
  ['ir', EU_WEST_1],
  ['iq', EU_WEST_1],
  ['il', EU_WEST_1],
  ['jo', EU_WEST_1],
  ['kw', EU_WEST_1],
  ['lb', EU_WEST_1],
  ['om', EU_WEST_1],
  ['ps', EU_WEST_1],
  ['qa', EU_WEST_1],
  ['sa', EU_WEST_1],
  ['sy', EU_WEST_1],
  ['tr', EU_WEST_1],
  ['ye', EU_WEST_1],

  // Asia-Pacific -> us-east-1
  ['af', US_EAST_1],
  ['am', US_EAST_1],
  ['az', US_EAST_1],
  ['bd', US_EAST_1],
  ['bt', US_EAST_1],
  ['bn', US_EAST_1],
  ['kh', US_EAST_1],
  ['cn', US_EAST_1],
  ['ge', US_EAST_1],
  ['in', US_EAST_1],
  ['id', US_EAST_1],
  ['jp', US_EAST_1],
  ['kz', US_EAST_1],
  ['kg', US_EAST_1],
  ['la', US_EAST_1],
  ['my', US_EAST_1],
  ['mv', US_EAST_1],
  ['mn', US_EAST_1],
  ['mm', US_EAST_1],
  ['np', US_EAST_1],
  ['pk', US_EAST_1],
  ['ph', US_EAST_1],
  ['sg', US_EAST_1],
  ['kr', US_EAST_1],
  ['lk', US_EAST_1],
  ['tw', US_EAST_1],
  ['tj', US_EAST_1],
  ['th', US_EAST_1],
  ['tl', US_EAST_1],
  ['tm', US_EAST_1],
  ['uz', US_EAST_1],
  ['vn', US_EAST_1],

  // Oceania -> us-east-1
  ['au', US_EAST_1],
  ['fj', US_EAST_1],
  ['ki', US_EAST_1],
  ['mh', US_EAST_1],
  ['fm', US_EAST_1],
  ['nr', US_EAST_1],
  ['nz', US_EAST_1],
  ['pw', US_EAST_1],
  ['pg', US_EAST_1],
  ['ws', US_EAST_1],
  ['sb', US_EAST_1],
  ['to', US_EAST_1],
  ['tv', US_EAST_1],
  ['vu', US_EAST_1],

  // Others & fallback
  ['aq', US_EAST_1],
  ['xx', US_EAST_1],
]);
